// extracted by mini-css-extract-plugin
export default {"listCards":"OutfitsList_listCards__tX-tx"};